import { useState } from 'react';

import { Box, Tab, Tabs } from '@mui/material';

import { useLocale } from '@shared/hooks/locale';

import { GRID_GAP } from './constants';
import { DashboardCMACard } from './dashboard-cma/DashboardCMACard';
import { DashboardEnquiriesCard } from './dashboard-enquiry/DashboardEnquiriesCard';
import { DashboardLeadsCard } from './dashboard-lead/DashboardLeadsCard';
import { DashboardListingsCard } from './dashboard-listings/DashboardListingsCard';
import { DashboardMlsShareRequestsCard } from './dashboard-mls-share-requests/DashboardMlsShareRequestsCard';
import { DashboardTasksCard } from './dashboard-task/DashboardTasksCard';
import { DashboardStatsCard } from './DashboardStatsCard';
import { CollapsibleFeed } from './shared/CollapsibleFeed';
import { useDashboardModules } from './shared/useDashboardModules';
import { type RetryableRef } from './types';

type DashboardMobileViewProps = {
  enquiriesRef: React.RefObject<RetryableRef | null>;
};

export const DashboardMobileView = ({
  enquiriesRef,
}: DashboardMobileViewProps) => {
  const { t } = useLocale();
  const { isBrokerageEnabled, isCMAEnabled } = useDashboardModules();
  const [activeTab, setActiveTab] = useState<'action' | 'performance'>(
    'action',
  );

  return (
    <>
      <Box
        sx={{
          borderBottom: '1px solid',
          borderColor: 'grey.200',
        }}
      >
        <Tabs
          value={activeTab}
          onChange={(_, val) => setActiveTab(val)}
          variant="fullWidth"
          textColor="primary"
          indicatorColor="primary"
          sx={{
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 500,
              minHeight: 40,
            },
          }}
        >
          <Tab value="action" label={t('Actions')} />
          <Tab value="performance" label={t('Performance')} />
        </Tabs>
      </Box>
      {activeTab === 'action' && (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 1fr)',
            gap: GRID_GAP,
          }}
        >
          {isBrokerageEnabled && <DashboardEnquiriesCard ref={enquiriesRef} />}
          <DashboardLeadsCard />
          <DashboardTasksCard />
          {isCMAEnabled && <DashboardCMACard />}
          {isBrokerageEnabled && <DashboardListingsCard />}
          {isBrokerageEnabled && <DashboardMlsShareRequestsCard />}

          <CollapsibleFeed />
        </Box>
      )}
      {activeTab === 'performance' && (
        <Box
          sx={{
            display: 'grid',
            gap: GRID_GAP,
            gridTemplateColumns: 'minmax(0, 1fr)',
          }}
        >
          <DashboardStatsCard />
        </Box>
      )}
    </>
  );
};
